import "../css/StorageQuotaBar.css";
import { formatValueUnit } from "../js/utils";

export const StorageQuotaBar = ({ data = {} }) => {
  const widthPercentage = Math.min(data.porcentajeOcupacion, 100);

  return (
    <div className="storage-quota-container">
      {/* Información superior */}
      <div className="storage-quota-info">
        <span className="storage-quota-text">
          {formatValueUnit(data.ocupacionCuotaValor, data.ocupacionCuotaUnidad)}{" "}
          de {formatValueUnit(data.maximoCuotaValor, data.maximoCuotaUnidad)} (
          {formatValueUnit(data.porcentajeOcupacion, "%")})
        </span>
      </div>
      {/* Barra de progreso */}
      <div className="storage-quota-bar-bg">
        <div
          className="storage-quota-bar-fill"
          style={{ width: `${widthPercentage}%` }}
        />
      </div>
    </div>
  );
};
